import React from 'react';

import BottomSheet from 'components/DesignSystem/BottomSheet';

import './index.scss';

export interface FilterField {
  label: string;
  value: string[];
  setValue: React.Dispatch<React.SetStateAction<string[]>>;
  options: string[];
}

export default function FilterSheet({
  open,
  dismiss,
  fields,
  onClear,
}: {
  open: boolean;
  dismiss: () => void;
  fields: FilterField[];
  onClear: () => void;
}) {
  const toggle = (field: FilterField, option: string) => {
    field.setValue((current) => (
      current.includes(option)
        ? current.filter((selected) => selected !== option)
        : [...current, option]
    ));
  };

  return (
    <BottomSheet open={open} dismiss={dismiss} title="Filtros">
      <div className="filter-sheet-fields">
        {fields.map((field) => (
          <div key={field.label} className="filter-sheet-field">
            <span className="filter-sheet-field-label">{field.label}</span>
            <div className="filter-sheet-chips">
              {field.options.map((option) => {
                const selected = field.value.includes(option);
                return (
                  <button
                    key={option}
                    type="button"
                    className={`filter-sheet-chip${selected ? ' selected' : ''}`}
                    aria-pressed={selected}
                    onClick={() => toggle(field, option)}
                  >
                    {option}
                  </button>
                );
              })}
            </div>
          </div>
        ))}
      </div>
      <button type="button" className="filter-sheet-clear" onClick={onClear}>
        Limpar Filtros
      </button>
    </BottomSheet>
  );
}
